import React from 'react';
import { useTranslation } from 'react-i18next'; // Add this import
import { Section4Icon } from 'icons';

export const Section4 = () => {
  const { t } = useTranslation(); // Hook for translations

  return (
    <section className="flex flex-col md:flex-row items-center px-smallPx md:px-mediumPx lg:px-largePx lg:h-[530px] py-10 md:space-y-0 space-y-5 md:space-x-10 space-x-0">
      <div className="py-10 md:py-0">
        <Section4Icon />
      </div>
      <div className="space-y-5 pb-10 md:pb-0">
        <div>
          <h1 className="text-[32px] font-[700] text-[#1E90AA]">
            {t('section4.whereWeOperate.title')}
          </h1>
          <p className="md:ml-5 text-justify md:text-left">
            {t('section4.whereWeOperate.description')}
          </p>
        </div>
        <div>
          <h1 className="text-[32px] font-[700] text-[#1E90AA]">
            {t('section4.whyChooseUs.title')}
          </h1>
          <p className="md:ml-5 text-justify md:text-left">
            {t('section4.whyChooseUs.description')}
            <ul className="list-disc list-inside">
              <li>{t('section4.whyChooseUs.list.expertConsultation')}</li>
              <li>{t('section4.whyChooseUs.list.seamlessInstallation')}</li>
              <li>{t('section4.whyChooseUs.list.afterSalesSupport')}</li>
            </ul>
          </p>
        </div>
      </div>
    </section>
  );
};

export default Section4;
